import BaseApi from "../../BaseApi";
import {headers} from "../../ApiSettings";

class Rokub extends BaseApi {
    constructor() {
        super({suffix: ""});
    }

    GetAllRokub(params) {
        return this.httpService.get("Definition/all-rokob", {headers, params})
    }

    EditPriceRokub(data) {
        return this.httpService.put("Definition/set-price-rokob", data, {headers})
    }

    EditRokub(data) {
        return this.httpService.put("Definition/update-rokob", data, {headers})
    }

    InsertRokubData(data) {
        return this.httpService.post("Definition/insert-rokob", data, {headers})
    }

    deleteRokub(data) {
        return this.httpService.delete("Definition/delete-rokob", {headers, data})
    }

    disableRokub(data) {
        return this.httpService.put("Definition/disable-rokob", data, {headers})
    }

    GetStruct(params) {
        return this.httpService.get("Definition/list-struct", {headers, params})
    }

    getRelationRokob(params) {
        return this.httpService.get("Definition/relation-rokob", {headers, params})
    }
}

const RokubService = new Rokub();
export default RokubService;
